// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 94 ? "pdfjsWorker" : chunkId) + "." + {"6":"07a79332","62":"d30201c2","94":"212a80b9"}[chunkId] + ".chunk.js";
};